import React, { useContext, useEffect } from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { PaymentContext } from "../contexts/Payment/payment.context";
import { usePayDataContext } from "../contexts/PayDataContext";

const Success = () => {
  const { merchantData } = usePayDataContext();
  const { state } = useContext(PaymentContext);
  const paymentReference = state.payment?.reference;

  useEffect(() => {
    if (paymentReference) {
      window.parent.postMessage(
        {
          action: "successful",
          data: {
            status: true,
            message: "Transaction was successful.",
            data: {
              status: "successful",
              reference: paymentReference,
            },
          },
        },
        "*"
      );
    }
  }, [paymentReference, merchantData.meta.redirect_url]);
  return (
    <div className="py-16 text-center">
      <div className="flex justify-center items-center">
        <div>
          <IoMdCheckmarkCircleOutline className="text-green-600 text-7xl" />
        </div>
      </div>
      <p className="text-xl mt-5 text-[var(--Checkout-text-color)] Inter-Semibold">
        Payment Successful
      </p>
      <p className="text-base py-7 Inter-Regular">
        Transaction Reference: {paymentReference}
      </p>
      {merchantData.meta.redirect_url && <p>Redirecting...</p>}
    </div>
  );
};

export default Success;
